const txteng17 = [
  ["Пойдем домой, холодает.", "Let's go home, it's getting cold"],
  ["Пей свой кофе, он остывает.", "Drink your coffee. It's getting cold."],
  ["Темнеет.", "It's getting dark."],
  [
    "Мне кажется, погода завтра ухудшится.",
    "I think, the weather will get worse tomorrow.",
  ],
  ["Держись, становится лучше", "Hang in there. It's gonna get better."],
  ["Я порчусь? (становлюсь хуже)", "Am I getting worse?"],
  ["Мне нужно подготовиться к экзаменам.", "I need to get ready for my exams."],
  ["Мы должны подготовиться к субботе.", "We're gonna get ready for Saturday."],
  ["Мы заблудились по пути", "We got lost along the way."],
  ["Я слышал ты женился", "I heard you got married."],
  [
    "Они влюбились, поженились и завели меня",
    "They fell in love and got married and had me.",
  ],
  ["Я женился и родил двух дочерей.", "I got married and had two doughters."],
  ["Я развелся", "I got divorced."],
];

export default txteng17;
